
<li :class="[prefixCls + '_wrapper']" v-show="!hidden">
  <div :class="[prefixCls + '_title']">{{ label }}</div>
  <ul>
    <li :class="[prefixCls]" ref="options"><slot></slot></li>
  </ul>
</li>
